import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

export const ProtectedRoute = ({ children }) => {
  const { admin, ready } = useAuth();
  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0B1121]">
        <Loader2 className="animate-spin text-white" size={32} />
      </div>
    );
  }
  if (!admin) return <Navigate to="/admin/login" replace />;
  return children;
};
